import { BACKEND_URL } from "../../config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const textingApi = createApi({
  reducerPath: "textingApi",
  // keepUnusedDataFor: 60, // Keeps data for 60 seconds
  // refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        // Include token in request header
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
    fetchFn: async (input, init) => {
      if (!input) {
        // Handle invalid input gracefully
        return new Response(null, {
          status: 400,
          statusText: "Invalid request",
        });
      }

      const response = await fetch(input, init);

      if (response.status === 204) {
        return new Response(JSON.stringify([]), { status: 200 }); // Transform 204 to an empty array
      }

      return response;
    },
  }),
  endpoints: (builder) => ({
    getCustomers: builder.query({
      query: ({keyword, location}) => {
        if (keyword.length < 3) {
          return ""; // Return empty string for invalid queries
        }
        return `/search/portal/get/customers?keyword=${keyword}&location=${location}`;
      },
      // Skip query for short keywords
      skip: (keyword) => keyword.length <= 3,
    }),
    getTemplates: builder.query({
      query: ({ template = "Notification", location = "Houston" }) => {
        return `/search/portal/get/template-tech-texts?view=${template}&location=${location}`;
      }
    }),
    getLegerCommunication: builder.query({
      query: (customerRec) => `/comm/portal/get/comms-ledger?techid=${customerRec}`,
    }),
    getEmployeeCommunication: builder.query({
      query: (name) => `/comm/portal/get/comms-employee?name=${name}`,
    }),
    getEmployeeByPestroutesId: builder.query({
      query: (pestroutesId) => `/search/portal/get/employee-by-pestroutes-id?pestroutesId=${pestroutesId}`,
    }),
    getEmployeeByRecid: builder.query({
      query: (recid) => `/search/portal/get/employee-by-recid?recid=${recid}`,
    }),
    getInitialServiceHeadsUp: builder.query({
      query: (customerId) => `/search/portal/get/initial-service-heads-up?customerId=${customerId}`,
    }),
  }),
});

export const {
  useGetCustomersQuery,
  useGetTemplatesQuery,
  useGetLegerCommunicationQuery,
  useGetEmployeeCommunicationQuery,
  useGetEmployeeByPestroutesIdQuery,
  useLazyGetEmployeeByPestroutesIdQuery,
  useGetEmployeeByRecidQuery,
  useLazyGetInitialServiceHeadsUpQuery,
} = textingApi;
